export default __webpack_public_path__ + "static/media/about_bg.ed21d611.jpg";